import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../../navbar/menuVertical/navbar';
import axiosInstance from '../../AxiosInterceptor/AxiosInterceptor';
import BuyerPersonaDetailEditor from '../../Charts/shared/BuyerPersonaDetailEditor';
import { cloneProfileArray, profilesHaveChanges } from '../../Charts/shared/profileUtils';
import SpinnerProcesando from '../../ComponentesMoleculas/Loader/SpinnerProcesando';
import '../BuyerPersonContainer.css';
import './BuyerPersonaEditar.css';

const BuyerPersonaEditar = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [navbarData, setNavbarData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState(null);
  const [clickState, setClickState] = useState(0);
  const [editableProfiles, setEditableProfiles] = useState([]);
  const [originalProfiles, setOriginalProfiles] = useState([]);
  const [updatingProfiles, setUpdatingProfiles] = useState(false);

  const countryFormat = localStorage.getItem('selectedItems') === '43' ? 'cl' : 'mx';

  useEffect(() => {
    const format = localStorage.getItem('selectedItems') === '43' ? 'cl' : 'mx';
    axiosInstance.get(
      `${process.env.REACT_APP_URL}/api/role/${localStorage.getItem('selectedCountry')}/enrichment/summary/${id}`,
    )
      .then((response) => {
        setValues(response.data);
        const profiles = format === 'cl' ? response.data.profile : response.data.perfil;
        if (profiles) {
          setEditableProfiles(cloneProfileArray(profiles));
          setOriginalProfiles(cloneProfileArray(profiles));
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && (error.response.status === 401 || error.response.status === 422)) {
          localStorage.clear();
          navigate('/iniciar-sesion');
        }
      });
  }, [id, navigate]);

  const profiles = countryFormat === 'cl' ? values?.profile : values?.perfil;
  const profileWeights = countryFormat === 'cl' && profiles
    ? profiles.map((item) => item.peso)
    : [];
  const organizationName = countryFormat === 'cl'
    ? values?.organizacion
    : values?.df_log?.[0]?.organization;
  const listName = values?.resumen_carga?.enrichment_name || '';

  const hasProfileChanges = profilesHaveChanges(originalProfiles, editableProfiles);

  const handleUpdateProfiles = () => {
    if (!hasProfileChanges || updatingProfiles) return;

    setUpdatingProfiles(true);
    axiosInstance.put(
      `${process.env.REACT_APP_URL}/api/role/${localStorage.getItem('selectedCountry')}/enrichment/update/${id}`,
      { profile: editableProfiles },
    )
      .then(() => {
        navigate('/inicio/buyer-persona');
      })
      .catch((error) => {
        setUpdatingProfiles(false);
        if (error.response && (error.response.status === 401 || error.response.status === 422)) {
          localStorage.clear();
          navigate('/iniciar-sesion');
        }
      });
  };

  return (
    <div className="containerBuyerPerson buyerPersonaEditPage">
      <Navbar estado={setNavbarData} />
      <div
        className={`bayerPerson_body_container buyerPersonaEditBody ${navbarData ? 'navbar-open' : ''}`}
        style={{ marginLeft: navbarData ? '228px' : '80px' }}
      >
        <header className="buyerPersonaEditHeader">
          <h1 className="buyerPersonaEditTitle">
            Editar Buyer Persona{listName ? ` — ${listName}` : ''}
          </h1>
        </header>

        <main className="buyerPersonaEditMain">
          {loading ? (
            <SpinnerProcesando />
          ) : profiles && profiles.length > 0 ? (
            <BuyerPersonaDetailEditor
              profiles={editableProfiles}
              profileWeights={profileWeights}
              clickState={clickState}
              onSelectProfile={setClickState}
              editMode={true}
              onChange={setEditableProfiles}
              countryFormat={countryFormat}
              organizationName={organizationName}
            />
          ) : (
            <p className="buyerPersonaEditEmpty">No hay perfiles disponibles para editar.</p>
          )}
        </main>

        {!loading && profiles && profiles.length > 0 && (
          <footer className="buyerPersonaEditFooter">
            <button
              type="button"
              className="buyerPersonaEditFooterCancel"
              onClick={() => navigate('/inicio/buyer-persona')}
              disabled={updatingProfiles}
            >
              Cancelar
            </button>
            {updatingProfiles ? (
              <SpinnerProcesando />
            ) : (
              <button
                type="button"
                className="buyerPersonaEditFooterUpdate"
                onClick={handleUpdateProfiles}
                disabled={!hasProfileChanges}
              >
                Actualizar
              </button>
            )}
          </footer>
        )}
      </div>
    </div>
  );
};

export default BuyerPersonaEditar;
